import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import { yearMonthDayDate } from "utils/dateHelpers"
import { DateInput } from "shared/inputs"

const NewTaskReportExportClosedDateFilters = () => {
  const {
    earliestClosedDate,
    includeClosedTasks,
    includeOpenTasks,
    latestClosedDate,
    setEarliestClosedDate,
    setLatestClosedDate,
  } = useTaskReportExportContext()

  // The range refines only the closed half of the export, which is worth saying only when the
  // export also holds open tasks for it not to apply to.
  const bothTaskStatusesIncluded = includeOpenTasks && includeClosedTasks

  return (
    <>
      <label aria-label="earliest closed date (mm/dd/yyyy)">
        <span aria-hidden>Earliest Date:</span>
        <DateInput
          className="mb-4"
          clearable
          max={latestClosedDate ? yearMonthDayDate(latestClosedDate) : yearMonthDayDate()}
          name="task_report_export_earliest_closed_date"
          onChange={setEarliestClosedDate}
          value={earliestClosedDate}
        />
      </label>
      <label aria-label="latest closed date (mm/dd/yyyy)">
        <span aria-hidden>Latest Date:</span>
        <DateInput
          className="mb-4"
          clearable
          min={earliestClosedDate ? yearMonthDayDate(earliestClosedDate) : null}
          max={yearMonthDayDate()}
          name="task_report_export_latest_closed_date"
          onChange={setLatestClosedDate}
          value={latestClosedDate}
        />
      </label>
      {
        bothTaskStatusesIncluded && (
          <p className="text-xs text-dark">
            Does not apply to open tasks.
          </p>
        )
      }
    </>
  )
}

export default NewTaskReportExportClosedDateFilters
